(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-lot-deals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('case-lot-shop')) {
  class CaseLotShop extends HTMLElement {
    connectedCallback() {
      if (this.initialized || !this.querySelector('[data-case-order]')) return;
      this.initialized = true;
      this.copy = JSON.parse(this.querySelector('[data-case-translations]').textContent);
      this.cards = [...this.querySelectorAll('[data-case-card]')];
      this.buttons = [...this.querySelectorAll('[data-case-checkout]')];
      this.format = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency});
      this.querySelectorAll('[data-case-controls], [data-case-order]').forEach(el => {el.hidden=false;});
      this.cards.forEach(card => {
        const input=card.querySelector('[data-case-quantity]');
        if (!input) return;
        card.querySelector('[data-case-minus]').addEventListener('click', () => this.setQuantity(card, Number(input.value)-1));
        card.querySelector('[data-case-plus]').addEventListener('click', () => this.setQuantity(card, Number(input.value)+1));
        input.addEventListener('change', () => this.setQuantity(card, Number(input.value)));
        input.addEventListener('input', () => {if(input.value !== '') this.setQuantity(card, Number(input.value));});
      });
      this.buttons.forEach(button => button.addEventListener('click', () => this.checkout()));
      this.render();
    }
    money(cents) {return this.format.format(cents/100);}
    label(key, values) {
      let text=this.copy[key];
      Object.entries(values).forEach(([name,value]) => {text=text.replaceAll(`__${name.toUpperCase()}__`, String(value));});
      return text;
    }
    setQuantity(card, value) {
      if(this.busy || this.uncertain || this.completed) return;
      const input=card.querySelector('[data-case-quantity]');
      const max=input.hasAttribute('max') ? Number(input.max) : 999;
      input.value=String(Math.min(max, Math.max(0, Number.isFinite(value) ? Math.floor(value) : 0)));
      this.render();
    }
    selection() {
      return this.cards.flatMap(card => {
        const input=card.querySelector('[data-case-quantity]');
        const quantity=input ? Number(input.value) : 0;
        if(!Number.isSafeInteger(quantity) || quantity<=0) return [];
        return [{id:Number(card.dataset.variant),quantity,price:Number(card.dataset.price),packs:Number(card.dataset.packs),title:card.dataset.title,retail:card.dataset.retail==='' ? null : Number(card.dataset.retail)}];
      });
    }
    render() {
      const selected=this.selection();
      const cases=selected.reduce((n,item)=>n+item.quantity,0);
      const packs=selected.reduce((n,item)=>n+item.quantity*item.packs,0);
      const subtotal=selected.reduce((n,item)=>n+item.quantity*item.price,0);
      const saving=selected.every(item=>Number.isFinite(item.retail)) ? selected.reduce((n,item)=>n+item.quantity*(item.retail-item.price),0) : null;
      this.querySelector('[data-case-total]').textContent=this.money(subtotal);
      this.querySelector('[data-case-sticky-total]').textContent=this.money(subtotal);
      this.querySelector('[data-case-count]').textContent=this.label(cases===1 ? 'single' : 'cases',{cases,packs});
      this.querySelector('[data-case-saving]').textContent=saving>0 ? this.label('savings',{amount:this.money(saving)}) : '';
      this.querySelector('[data-case-empty]').hidden=cases>0;
      this.querySelector('[data-case-sticky]').hidden=cases===0;
      const list=this.querySelector('[data-case-lines]');
      list.replaceChildren(...selected.map(item=>{
        const line=document.createElement('li');
        const name=document.createElement('span');name.textContent=`${item.quantity} × ${item.title}`;
        const total=document.createElement('strong');total.textContent=this.money(item.quantity*item.price);
        line.append(name,total);return line;
      }));
      this.cards.forEach(card=>{
        const input=card.querySelector('[data-case-quantity]');if(!input) return;
        card.dataset.selected=String(Number(input.value)>0);
        input.disabled=Boolean(this.busy || this.uncertain);
        card.querySelector('[data-case-minus]').disabled=Boolean(this.busy || this.uncertain || Number(input.value)<=0);
        card.querySelector('[data-case-plus]').disabled=Boolean(this.busy || this.uncertain || (input.hasAttribute('max') && Number(input.value)>=Number(input.max)));
      });
      this.buttons.forEach(button=>{
        button.disabled=Boolean(cases===0 || subtotal<Number(this.dataset.minimum) || this.busy || this.uncertain || this.completed);
        button.textContent=this.busy || this.completed ? this.copy.busy : cases>0 && subtotal<Number(this.dataset.minimum) ? this.label('minimum',{amount:this.money(Number(this.dataset.minimum)-subtotal)}) : cases>0 ? `${this.copy.checkout} · ${this.money(subtotal)} →` : this.copy.select;
      });
    }
    async readCart() {
      const response=await fetch(`${this.dataset.root}cart.js`, {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok) throw new Error('cart_read_failed');
      const cart=await response.json();
      if(!Array.isArray(cart.items) || cart.currency!==this.dataset.currency) throw new Error('cart_shape_invalid');
      return cart;
    }
    verified(cart, selected, marker, before) {
      if(!(cart.item_count>0)) return false;
      const added=cart.items.filter(item=>item.properties?._case_lot_selection===marker);
      if(added.length!==selected.length) return false;
      if(!selected.every(wanted=>{
        const actual=added.find(item=>Number(item.variant_id)===wanted.id);
        return actual && actual.quantity===wanted.quantity && !actual.selling_plan_allocation && Number.isFinite(actual.final_price) && actual.final_price<=wanted.price;
      })) return false;
      return before.items.every(old=>cart.items.some(item=>item.key===old.key && item.quantity>=old.quantity));
    }
    async checkout() {
      if(this.busy || this.uncertain || this.completed) return;
      const selected=this.selection();if(!selected.length || selected.reduce((n,item)=>n+item.price*item.quantity,0)<Number(this.dataset.minimum)) return;
      this.busy=true;this.render();
      const error=this.querySelector('[data-case-error]');
      const recovery=this.querySelector('[data-case-recover]');
      error.hidden=true;recovery.hidden=true;
      let sent=false;let before;let marker;
      try {
        before=await this.readCart();
        marker=crypto.randomUUID();
        const items=selected.map(item=>({id:item.id,quantity:item.quantity,properties:{_case_lot_selection:marker,_case_lot_campaign:'blowout-20260917'}}));
        sent=true;
        const response=await fetch(`${this.dataset.root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const cart=await this.readCart();
        if(this.verified(cart,selected,marker,before)) {
          if(window.tnmCaseShipping) await window.tnmCaseShipping.ensure(cart);
          if((await window.tnmFreeMeatGift?.ensure())?.safe!==true) throw new Error('Free packs not verified');
          this.completed=true;window.location.assign(`${this.dataset.root}checkout`);
          return;
        }
        this.uncertain=cart.items.some(item=>item.properties?._case_lot_selection===marker);
        error.textContent=response.ok ? this.copy.error : this.copy.stock;
        error.hidden=false;recovery.hidden=!this.uncertain;
      } catch (_) {
        this.uncertain=sent;
        if(sent && before && marker) {
          try {
            const cart=await this.readCart();
            if(this.verified(cart,selected,marker,before)) {
              if(window.tnmCaseShipping) await window.tnmCaseShipping.ensure(cart);
              if((await window.tnmFreeMeatGift?.ensure())?.safe===true) {
                this.completed=true;window.location.assign(`${this.dataset.root}checkout`);return;
              }
            }
            this.uncertain=cart.items.some(item=>item.properties?._case_lot_selection===marker);
          } catch (_) {this.uncertain=true;}
        }
        error.textContent=this.copy.error;error.hidden=false;recovery.hidden=!this.uncertain;
      } finally {
        this.busy=false;this.render();
        if(!error.hidden) error.scrollIntoView({behavior:'auto',block:'center'});
      }
    }
  }
  customElements.define('case-lot-shop', CaseLotShop);
}

  } catch(e) { console.error(e); }
})();
})();
